module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionStart.c6fb9802.png";